(ns minorodata.data-views.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))

(declare ->data-views-page
         ->data-view
         ->data-views-all
         ->data-views-shared
         ->data-views-created)

(m/defmodel data-views-page
  {:sidebar-tab   [::m/string ::m/nilable "Selected tab"]
   :data-view-id  [::m/string ::m/nilable "Selected data-view id"]
   :sidebar-width [::m/number ::m/nilable "Sidebar width"]
   :editor-height [::m/number ::m/nilable "Editor height"]
   :show-editor   [::m/bool ::m/nilable "Editor's visibility"]
   :editor-code   [::m/string ::m/nilable "Editor code"]
   :data          [::m/vector ::m/nilable "Vector of results"]
   :results-tab   [::m/number "Currently selected results tab"]
   :downloading?  [::m/bool ::m/nilable "Is downloading file"]

   :share-data-view-modal-open?  [::m/bool ::m/nilable "Share modal visibility"]
   :delete-data-view-modal-open? [::m/bool ::m/nilable "Delete modal visibility"]}
  {:singleton true})

(m/defmodel data-view
  {:data-view-id [::m/identity ::m/req ::m/string "Unique id"]
   :name         [::m/string ::m/nilable "Data view title"]
   :description  [::m/string ::m/nilable "Data view description"]
   :client-id    [::m/string "Client id"]
   :updated-by   {::m/type     ::m/ref
                  ::m/ref-type searchable-user
                  ::m/doc      "Related user"}
   :created-by   {::m/type     ::m/ref
                  ::m/ref-type searchable-user
                  ::m/doc      "Related user"}
   :updated-at   [::m/string "Updated date"]
   :created-at   [::m/string "Created date"]
   :last_run     [::m/string "Last run date"]
   :command      [::m/string "Original SQL"]
   :order        [::m/number ::m/nilable "UI only field to preserve the display order"]})


(m/defmodel data-views-all
  {:data-views     {::m/type        ::m/ref
                    ::m/cardinality ::m/many
                    ::m/ref-type    data-view
                    ::m/doc         "Link to data-view"}
   :total-pages    [::m/number]
   :page           [::m/number]
   :items-per-page [::m/number]}
  {:singleton true})


(m/defmodel data-views-shared
  {:data-views {::m/type        ::m/ref
                ::m/cardinality ::m/many
                ::m/ref-type    data-view
                ::m/doc         "Link to data-view"}
   :total-pages    [::m/number]
   :page           [::m/number]
   :items-per-page [::m/number]}
  {:singleton true})

(m/defmodel data-views-created
  {:data-views {::m/type        ::m/ref
                ::m/cardinality ::m/many
                ::m/ref-type    data-view
                ::m/doc         "Link to data-view"}
   :total-pages    [::m/number]
   :page           [::m/number]
   :items-per-page [::m/number]}
  {:singleton true})
